export default {
    //check device
    checkAndGetOsName: () => {
        let detectedOS = "UNKNOWN";
        const hasWindow = typeof window !== "undefined";
        const nav = typeof navigator !== "undefined" ? navigator : { userAgent: "", vendor: "", appVersion: "" };
        const userAgent = nav.userAgent || nav.vendor || (hasWindow ? window.opera : "");
        const appVersion = nav.appVersion || "";
        const msStream = hasWindow ? window.MSStream : undefined;
        if (appVersion.indexOf("Mac") !== -1)
            detectedOS = "MACOS";
        if (appVersion.indexOf("Win") !== -1)
            detectedOS = "WINDOWS";
        if (appVersion.indexOf("Linux") !== -1)
            detectedOS = "LINUX";
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }
        if (/android/i.test(userAgent)) {
            return "Android";
        }
        if (/iPad|iPhone|iPod/.test(userAgent) && !msStream) {
            return "iOS";
        }
        return detectedOS;
    },
    //get browser name
    getBrowserName: () => {
        const userAgent = typeof navigator !== "undefined" ? navigator.userAgent : "";
        let browserName;
        if (userAgent.match(/chrome|chromium|crios/i)) {
            browserName = "CHROME";
        }
        else if (userAgent.match(/firefox|fxios/i)) {
            browserName = "FIREFOX";
        }
        else if (userAgent.match(/safari/i)) {
            browserName = "SAFARI";
        }
        else if (userAgent.match(/opr\//i)) {
            browserName = "OPERA";
        }
        else if (userAgent.match(/edg/i)) {
            browserName = "EDGE";
        }
        else {
            browserName = "UNKNOWN";
        }
        return browserName;
    },
};
